<template>
  <div class="home">
    <!--<img alt="Vue logo" src="../assets/logo.png">-->
    <!--
    <Calendar
      v-if="!showNavigationButtons"
      :inline="true"
      dateFormat="dd.mm.yy"
      :locale="locale"
    ></Calendar>
    -->
    <!--<FullCalendar :options="calendarConfig" />-->
    <HelloWorld
      v-if="!showNavigationButtons"
      msg="Test verschiedener Techniken"
    />
    <h1 v-if="showNavigationButtons">Schnellzugriff</h1>
    <div v-if="showNavigationButtons">
      <Button
        v-for="b in buttons"
        :key="b.label"
        :label="b.label"
        @click="goto(b.to)"
      />
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";

import HelloWorld from "@/components/HelloWorld.vue";

import env from "../../environments/env.json";
import { getStudioKuerzel } from "../api/http";

export default {
  name: "Home",
  components: {
    HelloWorld,
  },
  data() {
    return {
      locale: {
        firstDayOfWeek: 1,
        dayNames: [
          "Sonntag",
          "Montag",
          "Dienstag",
          "Mittwoch",
          "Donnerstag",
          "Freitag",
          "Samstag",
        ],
        dayNamesShort: ["Son", "Mon", "Die", "Mit", "Don", "Fre", "Sam"],
        dayNamesMin: ["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"],
        monthNames: [
          "Januar",
          "Februar",
          "März",
          "April",
          "Mai",
          "Juni",
          "Juli",
          "August",
          "September",
          "Oktober",
          "November",
          "Dezember",
        ],
        monthNamesShort: [
          "Jan",
          "Feb",
          "Mär",
          "Apr",
          "Mai",
          "Jun",
          "Jul",
          "Aug",
          "Sept",
          "Okt",
          "Nov",
          "Dez",
        ],
        today: "Heute",
        clear: "Leeren",
        dateFormat: "dd.mm.yyyy",
        weekHeader: "KW",
      },
      calendarConfig: {
        firstDay: 1,
        locale: "de",
        plugins: [dayGridPlugin, timeGridPlugin, interactionPlugin],
        defaultView: "dayGridMonth",
        defaultDate: "2020-04-20",
        header: {
          left: "prev,next",
          center: "title",
          right: "dayGridMonth,timeGridWeek,timeGridDay",
        },
        editable: true,
      },
      buttons: [],
    };
  },
  mounted() {
    this.$znaApi.getStudios().subscribe((studios) => {
      this.buttons.push(
        ...studios.map((studio) => {
          const label = "Studioplan " + getStudioKuerzel(studio.bezeichner);
          return {
            label,
            icon: "pi pi-fw pi-align-left",
            to: "/termine/" + studio.bezeichner,
          };
        }),
        {
          label: "Dienstplan",
          icon: "pi pi-fw pi-bars",
          to: "/dienstplan",
        }
      );
    });
  },
  computed: {
    showNavigationButtons() {
      return env.isProd;// || true;
    },
  },
  methods: {
    goto(url) {
      this.$router.push(url);
    },
  },
};
</script>
